type GetCodeProps = {
  projectId: string;
  country: string;
  language: string;
  version: string;
  clientId?: number;
  redirectUri?: string;
};

export const getExampleCode = ({
  projectId,
  country,
  language,
  version,
  clientId,
  redirectUri
}: GetCodeProps): string => {
  const requiredParams = () => {
    if (!clientId) {
      return `projectId: '${projectId}',
            login_url: 'your callback url',
            locale: '${language}_${country}'`;
    }

    return `projectId: "${projectId}",
            locale: "${language}_${country}",
            scope: 'offline',
            state: 'yourStateHere',
            response_type: 'code'
            clientId: "${clientId}",
            redirect_uri: "${redirectUri}"`;
  };

  return `  
  <script type="application/javascript">
    var s = document.createElement('script');
    s.type = "text/javascript";
    s.async = true;
    s.src = "https://cdn.xsolla.net/xsolla-login-widget/sdk/${version.substring(1)}/xl.min.js";
    s.addEventListener('load', function () {
        XL.init({
            ${requiredParams()}
        });

        // use 'XL.show();' function for widget fullscreen mode

    }, false);
    var head = document.getElementsByTagName('head')[0];
    head.appendChild(s);
  </script>`;
};
